import styled from 'styled-components';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { getSizeBy, getColor, getColorShade, getThemeProp, getElevation } from '../../../src/styled/utils';
const ResponsiveGridLayout = WidthProvider(Responsive);
export const StyledResponsiveGridLayout = styled(ResponsiveGridLayout) `
  height: 100%;
  min-height: 100%;

  .react-grid-item.react-grid-placeholder {
    background: ${getColorShade('primary', 'selected')};
    border: 1px dashed ${getColorShade('primary', 'highEmphasis')};
    border-radius: ${getThemeProp('widgetsBorderRadius')}px;
    opacity: 1;
  }

  .react-grid-item.react-draggable-dragging {
    background: ${getColorShade('primary', 'pressed')};
    box-shadow: ${getElevation(8)};
  }

  .react-grid-item > .react-resizable-handle::after {
    right: ${getSizeBy(1)};
    bottom: ${getSizeBy(1)};
    width: 0;
    height: 0;
    border-right: none;
    border-bottom: ${getSizeBy(3)} solid ${getColor('onSurface', 'mediumEmphasis')};
    border-left: ${getSizeBy(3)} solid transparent;
  }
`;
